export default __webpack_public_path__ + "static/media/Chery-Book-A-Test-Drive.136800e5.webp";